<ion-header class="modal-header">
  <div class="modal-title">
    <h3>
      {{ id ? 'Edit Knowledgebase Source' : 'Add to Knowledge Base' }}
    </h3>
  </div>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="clear" shape="round" class="close-button" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div style="padding: 13px 13px 0 13px" *ngIf="!id">
    <ion-grid class="no-padding">
      <ion-row>
        <ion-col size="6">
          <ion-card
            class="type-card depthButton"
            (click)="selectWebType()"
            [ngClass]="{ 'card-selected': !showIntegrationList && type === KNOWLEDGE_BASE_TYPES.WEB }"
          >
            <ion-card-header>
              <h3><ion-icon name="globe-outline"></ion-icon></h3>
              <ion-label>Webpage</ion-label>
            </ion-card-header>
          </ion-card>
        </ion-col>
        <ion-col size="6">
          <ion-card
            class="type-card depthButton"
            (click)="selectInternalWikiView()"
            [ngClass]="{ 'card-selected': showIntegrationList }"
          >
            <ion-card-header>
              <h3><ion-icon name="documents-outline"></ion-icon></h3>
              <ion-label>Internal wiki</ion-label>
            </ion-card-header>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  <div
    *ngIf="
      id &&
      (type === KNOWLEDGE_BASE_TYPES.NOTION ||
        type === KNOWLEDGE_BASE_TYPES.CONFLUENCE ||
        type === KNOWLEDGE_BASE_TYPES.GOOGLE_DRIVE ||
        type === KNOWLEDGE_BASE_TYPES.WIKI_JS ||
        type === KNOWLEDGE_BASE_TYPES.CODA)
    "
    style="text-align: center; font-size: 1.5rem; margin: 60px 20px; font-weight: 600"
  >
    <ion-icon
      style="font-size: 3.5rem; margin-right: 10px"
      [name]="
        type === KNOWLEDGE_BASE_TYPES.NOTION
          ? 'custom-notion'
          : type === KNOWLEDGE_BASE_TYPES.CONFLUENCE
            ? 'custom-confluence'
            : type === KNOWLEDGE_BASE_TYPES.GOOGLE_DRIVE
              ? 'custom-google-drive'
              : type === KNOWLEDGE_BASE_TYPES.WIKI_JS
                ? 'custom-wiki-js'
                : type === KNOWLEDGE_BASE_TYPES.CODA
                  ? 'custom-coda'
                  : ''
      "
    ></ion-icon>
    {{
      type === KNOWLEDGE_BASE_TYPES.NOTION
        ? 'Notion'
        : type === KNOWLEDGE_BASE_TYPES.CONFLUENCE
          ? 'Confluence'
          : type === KNOWLEDGE_BASE_TYPES.GOOGLE_DRIVE
            ? 'Google Drive'
            : type === KNOWLEDGE_BASE_TYPES.WIKI_JS
              ? 'Wiki.js'
              : type === KNOWLEDGE_BASE_TYPES.CODA
                ? 'Coda'
                : ''
    }}
  </div>
  <ion-card class="detail-card" [disabled]="isLoading" *ngIf="!showIntegrationList">
    <ion-card-content>
      <ng-container *ngIf="type === KNOWLEDGE_BASE_TYPES.WEB">
        <ion-label class="input-label">
          {{ type === KNOWLEDGE_BASE_TYPES.WEB ? 'Base URL' : 'Link' }}
        </ion-label>
        <ion-input
          #urlInput
          placeholder="e.g. https://docs.unthread.io/"
          [(ngModel)]="url"
          class="input-field"
          type="url"
          [disabled]="type === KNOWLEDGE_BASE_TYPES.WEB && id"
        >
        </ion-input>
        <p *ngIf="!id && type === KNOWLEDGE_BASE_TYPES.WEB" style="margin-bottom: 15px">
          Enter a base URL and the crawler will automatically crawl all articles and subpages
        </p>
      </ng-container>

      <ng-container *ngIf="type === KNOWLEDGE_BASE_TYPES.CONFLUENCE">
        <ion-label class="input-label"> Page IDs (subpages will be added automatically) </ion-label>
        <ion-input
          #pageIdsAllowlistInput
          [placeholder]="'12345,23456'"
          [(ngModel)]="pageIdsAllowlist"
          class="input-field"
        ></ion-input>
      </ng-container>

      <ng-container *ngIf="type === KNOWLEDGE_BASE_TYPES.GOOGLE_DRIVE">
        <ion-label class="input-label">Shared Drive IDs</ion-label>
        <ion-input
          #sharedDriveIdsInput
          [placeholder]="'12345,23456'"
          [(ngModel)]="sharedDriveIds"
          class="input-field"
        ></ion-input>
      </ng-container>

      <ng-container *ngIf="type === KNOWLEDGE_BASE_TYPES.GOOGLE_DRIVE">
        <ion-label class="input-label"> Add this email address to your Shared Drive sharing section: </ion-label>
        <ion-input
          class="input-field"
          style="background: var(--ion-color-step-50)"
          value="{{ authService.tenantId }}@unthread.iam.gserviceaccount.com"
          readonly="true"
        ></ion-input>
      </ng-container>

      <ion-label class="input-label"> Visibility: </ion-label>
      <ion-label text-wrap style="margin: 6px 0">
        <ion-chip
          mode="ios"
          color="success"
          class="chip"
          *ngIf="!userGroups?.length"
          style="height: 20px; padding: 6px"
          (click)="addUserGroup()"
        >
          Public
        </ion-chip>
        <ion-chip
          mode="ios"
          color="dark"
          class="chip tag-chip"
          style="margin: 0 7px"
          *ngFor="let userGroup of userGroups ?? []"
          (click)="removeUserGroup(userGroup.id)"
        >
          <ion-label> {{ userGroup.name }} </ion-label>
        </ion-chip>
        <ion-chip
          mode="ios"
          color="dark"
          class="chip tag-chip tag-chip-light"
          (click)="addUserGroup()"
          style="background: transparent"
          ngxTippy
          [tippyProps]="{
            touch: false,
            arrow: false,
            placement: 'bottom',
            content: 'Restrict document access to certain user groups'
          }"
        >
          <ion-label>
            <ion-icon name="lock-closed-outline"></ion-icon
            ><ion-icon name="add-outline" style="margin-left: -3px"></ion-icon>
          </ion-label>
        </ion-chip>
      </ion-label>
    </ion-card-content>
  </ion-card>
  <ion-card class="detail-card" *ngIf="showIntegrationList">
    <ion-list class="transparent-bg" lines="full">
      <ion-item *ngFor="let integration of integrations">
        <ion-icon *ngIf="integration.key === 'notion'" name="custom-notion"></ion-icon>
        <ion-icon *ngIf="integration.key === 'confluence'" name="custom-confluence"></ion-icon>
        <ion-icon *ngIf="integration.key === 'google-drive'" name="custom-google-drive"></ion-icon>
        <ion-icon *ngIf="integration.key === 'wiki-js'" name="custom-wiki-js"></ion-icon>
        <ion-icon *ngIf="integration.key === 'coda'" name="custom-coda"></ion-icon>
        <ion-label>
          <span class="text-with-left-icon"> {{ integration.name }} </span></ion-label
        >
        <ion-button (click)="createKBIntegration(integration)">Connect</ion-button>
      </ion-item>
    </ion-list>
  </ion-card>
  <div style="margin: 15px; text-align: center" *ngIf="type === KNOWLEDGE_BASE_TYPES.WEB && !showIntegrationList">
    <ion-button fill="clear" (click)="showAdvanced = !showAdvanced">
      <span *ngIf="showAdvanced">
        Hide advanced
        <ion-icon name="chevron-up-outline"></ion-icon>
      </span>
      <span *ngIf="!showAdvanced">
        Show advanced
        <ion-icon name="chevron-down-outline"></ion-icon>
      </span>
    </ion-button>
  </div>
  <ion-card class="detail-card" *ngIf="showAdvanced">
    <ion-card-content>
      <ng-container *ngIf="type === KNOWLEDGE_BASE_TYPES.WEB">
        <ion-label class="input-label"> Recursive? </ion-label>
        <label class="switch" style="display: block">
          <input type="checkbox" [(ngModel)]="isRecursive" />
          <span class="slider"></span>
        </label>
        <ion-label class="input-label"> URL Allowlist (comma-separated) </ion-label>
        <ion-input
          #urlAllowlistInput
          [placeholder]="'e.g. https://docs.unthread.io/article'"
          [(ngModel)]="urlAllowlist"
          class="input-field"
        ></ion-input>
        <ion-label class="input-label"> URL Blocklist (comma-separated) </ion-label>
        <ion-input
          #urlBlocklistInput
          [placeholder]="'e.g. https://docs.unthread.io/changelog'"
          [(ngModel)]="urlBlocklist"
          class="input-field"
        ></ion-input>
        <ion-label class="input-label"> Cookie (if password-protected page) </ion-label>
        <ion-textarea
          placeholder="Paste in from your browser"
          [(ngModel)]="cookie"
          class="input-field"
          rows="4"
          [autoGrow]="true"
        ></ion-textarea>
        <ion-text color="warning" *ngIf="cookie">Recommended: update this cookie each time you sync</ion-text>
      </ng-container>

      <ng-container *ngIf="type === KNOWLEDGE_BASE_TYPES.CONFLUENCE">
        <ion-label class="input-label"> Page ID Blocklist </ion-label>
        <ion-input
          #pageIdsBlocklistInput
          [placeholder]="'12345,23456'"
          [(ngModel)]="pageIdsBlocklist"
          class="input-field"
        ></ion-input>
      </ng-container>

      <ng-container *ngIf="type === KNOWLEDGE_BASE_TYPES.GOOGLE_DRIVE">
        <ion-button (click)="openGoogleDriveFilePicker()">Share files using Google Drive Picker</ion-button>
      </ng-container>
    </ion-card-content>
  </ion-card>
</ion-content>

<ion-footer *ngIf="!showIntegrationList">
  <div class="upgrade-feature-banner" *ngIf="isAddingExternalSource">
    <div class="constrained-content flex-space-between" style="align-items: center">
      <div>
        <p style="font-weight: 600">
          Heads up! It looks like you're trying to add documentation from {{ currentDomain }} which isn't a domain you
          own.
        </p>
        <p>This is a limited feature, so please contact us to add this.</p>
      </div>

      <ion-button fill="outline" color="light" class="btn-small" (click)="contactSupport()">
        Contact support
      </ion-button>
    </div>
  </div>
  <div class="footer flex-space-between">
    <ion-button (click)="submit()" [disabled]="isLoading" class="no-margin">
      Save
      <ion-spinner name="crescent" [hidden]="!isLoading" style="margin-left: 10px"></ion-spinner>
    </ion-button>
    <ion-button color="danger" fill="clear" (click)="delete()" [disabled]="isLoading" *ngIf="id" class="no-margin">
      Delete
    </ion-button>
  </div>
</ion-footer>
